module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    ref: "dialog",
    staticStyle: {
      "min-width": "1280px"
    },
    attrs: {
      "title": "导入数据",
      "size": "large"
    }
  }, [_c('div', {
    staticClass: "form-tips fz-14 m-b-10"
  }, [_vm._v("特殊文本输入格式（按顺序输入）：控件类型 | 字段名 | 字段标题 | 提示信息 | 是否必填（0为否，1为是)， 如果字段为空，则留白，一行一条数据。")]), _vm._v(" "), _c('el-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    domProps: {
      "value": (_vm.type)
    },
    on: {
      "input": function($event) {
        _vm.type = $event
      }
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "text"
    }
  }, [_vm._v("特殊文本")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "json"
    }
  }, [_vm._v("JSON数据")])]), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.text),
      expression: "text"
    }],
    attrs: {
      "type": "textarea",
      "rows": 8,
      "placeholder": "请输入内容"
    },
    domProps: {
      "value": (_vm.text)
    },
    on: {
      "input": function($event) {
        _vm.text = $event
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer m-b-10",
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("导入")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-307e434a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Model/textImport.vue
// module id = 1812
// module chunks = 2